// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GLVM","type":"styles_type__2E1AQ","choices":"styles_choices__mRzxg"};